import { useState } from 'react'
import { LocalStorageKeys } from '../../../constants/local-storage-keys'
import { DesignerTasksScale } from '../types/scale'

const readScale = (): DesignerTasksScale => {
    try {
        return localStorage.getItem(LocalStorageKeys.DesignerTasksScale) === 'large' ? 'large' : 'normal'
    } catch {
        return 'normal'
    }
}

const useDesignerTasksScale = () => {
    const [scale, setScaleState] = useState<DesignerTasksScale>(readScale)

    const setScale = (value: DesignerTasksScale) => {
        setScaleState(value)
        try {
            localStorage.setItem(LocalStorageKeys.DesignerTasksScale, value)
        } catch (error) {
            console.warn('Failed to save designer tasks scale:', error)
        }
    }

    return { scale, setScale }
}

export default useDesignerTasksScale
